<template>
    <div class="heading-special">
        <div class="title-line"></div>
        <div class="title-bar-block low" :style="{ width: barWidth }">
            <div class="title-bar"></div>
        </div>
        <div class="container title-block-container" ref="titleBlockContainer">
            <div class="title-block low" ref="titleBlock">
                <h1 class="title">
                    <slot></slot>
                </h1>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                barWidth: 0
            }
        },

        methods: {
            calcWidth() {
                let viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
                let containerWidth = this.$refs.titleBlockContainer.offsetWidth
                let titleBlockWidth = this.$refs.titleBlock.offsetWidth + 107;
                let titleBarWidth = ((viewportWidth - containerWidth) / 2) + titleBlockWidth;

                this.barWidth = (this.$mq !== 'sm' && this.$mq !== 'xs') ? titleBarWidth + 'px' : '100%'
            }
        },

        created() {
            window.addEventListener('resize', this.calcWidth);
        },

        destroyed() {
            window.removeEventListener('resize', this.calcWidth);
        },

        mounted () {
            this.calcWidth()
        },
    }
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';

.heading-special {
    position: relative;

    .title-line {
        display: none;

        @media ($md) {
            display: block;
            position: absolute;
            bottom: 42px;
            height: 1px;
            background-color: rgba(156, 156, 156, 0.32);
            width: 100%;
        }
    }

    .title-bar-block {
        height: 90px;

        .title-bar {
            background-color: #303030;
            position: relative;
            width: 100%;
            height: 100%;
            display: block;

            &::after {
                content: '';
                display: block;
                width: 74px;
                height: 7px;
                background-color: $primary-red;
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
            }
        }
    }

    .title-block-container {
        .title-block {
            position: absolute;
            bottom: 0;
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 130px;

            &.low {
                height: 94px;

                @media ($md) {
                    height: 93px;
                }
            }

            .title {
                color: #FFF;
                margin-bottom: 0;
                margin-left: 15px;
                font-family: "Conv_DB Helvethaica X Bd";
                font-size: 44px;
                line-height: 1;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// resources/js/components/motor-show/HeadingSpecial.vue